import { __assign, __extends } from "tslib";
import { CancellablePromise } from '@lifaon/observables';
import { ROUTE_PRIVATE } from './privates';
import { ConstructRoute } from './constructor';
import { ResolvableTree } from '../resolvable-tree/implementation';
import { CreateResolvableTreeResolver } from '../resolvable-tree/functions';
import { $super } from '../../misc/instance/snippets';
export function CreateRouteResolver() {
    return CreateResolvableTreeResolver({
        resolve: function (options) {
            var instance = this;
            var privates = instance[ROUTE_PRIVATE];
            var normalizedOptions = options;
            var path = privates.pathMatcher.exec(normalizedOptions.path);
            if (path === null) {
                return CancellablePromise.resolve({ resolved: false }, normalizedOptions);
            }
            else {
                return privates.resolve.call(instance, normalizedOptions)
                    .then(function (resolved) {
                    var childrenOptions = resolved
                        ? (__assign(__assign({}, normalizedOptions), { path: path.remaining }))
                        : void 0;
                    var resolvePathOptions = childrenOptions;
                    return {
                        resolved: resolved,
                        childrenOptions: childrenOptions,
                        resolvePathOptions: resolvePathOptions,
                    };
                });
            }
        },
        resolvePath: function (options, path) {
            var instance = this;
            return CancellablePromise.try(function () {
                var isFinalRoute = ((options.path === '')
                    && (instance.exec !== null));
                if (path.length === 0) {
                    if (isFinalRoute) {
                        return [instance];
                    }
                    else {
                        return [];
                    }
                }
                else {
                    return [instance].concat(path);
                }
            }, options);
        }
    });
}
var ROUTE_RESOLVER = CreateRouteResolver();
export function RouteGetPathMatcher(instance) {
    return instance[ROUTE_PRIVATE].pathMatcher;
}
export function RouteGetExec(instance) {
    return instance[ROUTE_PRIVATE].exec;
}
var Route = (function (_super) {
    __extends(Route, _super);
    function Route(path, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        var _options = __assign(__assign({}, options), { resolve: ROUTE_RESOLVER });
        _this = _super.call(this, _options) || this;
        ConstructRoute(_this, path, options);
        return _this;
    }
    Object.defineProperty(Route.prototype, "children", {
        get: function () {
            return $super(this, ResolvableTree).get('children');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Route.prototype, "pathMatcher", {
        get: function () {
            return RouteGetPathMatcher(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Route.prototype, "exec", {
        get: function () {
            return RouteGetExec(this);
        },
        enumerable: true,
        configurable: true
    });
    Route.prototype.resolve = function (options) {
        return _super.prototype.resolve.call(this, options);
    };
    return Route;
}(ResolvableTree));
export { Route };
//# sourceMappingURL=implementation.js.map